import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { convertFiltersToV5Format } from '../../utils/filterFormatConversionToV5';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listAuditLogs = (payload) => (dispatch) => {
  const { auditLogs } = store.getState();

  dispatch({
    type: REDUX_ACTIONS.AUDIT_LOGS_LIST_LOADING,
  });

  const body = {
    input: {
      startDate: payload?.startDate || auditLogs?.startDate,
      endDate: payload?.endDate || auditLogs?.endDate,
      searchValue: payload?.searchValue || auditLogs?.searchValue,
      limit: 100,
      page: payload?.page || 1,
      filters: convertFiltersToV5Format(auditLogs?.filters?.items) || [],
      linkOperator: auditLogs?.filters?.logicOperator || '',
      sort: auditLogs?.sort || null
    }
  };

  return fetch
    .post('audit', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.AUDIT_LOGS_LIST_SUCCESS,
        payload: {
          auditLogs: data.data.data,
          paginatedElements: data.data.count,
          totalCount: data.data.count
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.AUDIT_LOGS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
